// extracted by mini-css-extract-plugin
export default {"ranking__container--empty-state":"styles_ranking__container--empty-state__eaZJg"};